var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CircularLayout"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"anchor",style:({ transform: ("rotate(" + (item.deg) + "deg) translateY(0em)") })},[_vm._t("default",null,{"index":i})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }